import React, { useEffect, useState } from "react";
import NotificationCard from "./components/notificationCard/notificationCard";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) return;

        const response = await fetch(`${BACKEND_URL}/notifications`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await response.json();
        if (response.ok) {
          console.log("📦 Raw notifications:", data.notifications);
          setNotifications(data.notifications);
        } else {
          console.error("❌ Error fetching notifications:", data.message);
        }
      } catch (error) {
        console.error("❌ Error fetching notifications:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, []);

  const handleDelete = async (id) => {
  try {
    const token = localStorage.getItem("token");
    if (!token) return;

    const response = await fetch(`${BACKEND_URL}/notifications/${id}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.ok) {
      setNotifications((prev) => prev.filter((noti) => noti.id !== id));
      console.log(`🗑️ Deleted notification ${id}`);
    } else {
      const errorData = await response.json();
      console.error("❌ Failed to delete notification:", errorData.message);
    }
  } catch (error) {
    console.error("❌ Error deleting notification:", error);
  }
};


  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-semibold text-gray-900 mb-6">Notifications</h1>

      {loading ? (
        <p className="text-gray-500">Loading...</p>
      ) : notifications.length > 0 ? (
        <div className="w-full flex flex-col space-y-2">
          {notifications.map((n) => (
            <NotificationCard key={n.id} notification={n} onDelete={handleDelete} />
          ))}
        </div>
      ) : (
        <p className="text-gray-500">You're all caught up!</p>
      )}
    </div>
  );
};

export default NotificationsPage;
